import { OpenInNew } from "@mui/icons-material";
import AcxButton from "components/UI/AcxButton";
import React from "react";
import { Link } from "react-router-dom";

interface GoToConversationProps {
    conversationId: string;
}

export function GoToConversation({ conversationId }: GoToConversationProps) {
    return (
        <Link className="pendo-ignore"
            to={`/app/conversations/${conversationId}`}
            target="_blank"
            style={{
                textDecoration: "none",
            }}
        >
            <AcxButton color="white" endIcon={<OpenInNew fontSize="small" />}>
                Go to Conversation
            </AcxButton>
        </Link>
    );
}
